export enum CustomFieldType {
  TEXT='TEXT',
  NUMBER='NUMBER',
  CATEGORY='CATEGORY'
}

export enum CbsFieldGroup {
  ACCOUNT='ACCOUNT',
  DEPOSIT='DEPOSIT',
  LOAN='LOAN',
  CUSTOMER='CUSTOMER'
}
